/**
 * <CancelFeesSkeleton> — la forme de l'étape 3 de la résiliation pendant le calcul des frais.
 *
 * La tête d'étape reste (son titre, sa barre, le retour et la croix) : c'est le corps qui attend.
 * La phrase d'introduction, la carte du montant (`<CancelFeesCardSkeleton>`), l'encart « ce qui
 * se passe ensuite » — l'encart d'information est toujours un encart d'information, il garde sa
 * vraie surface —, puis les deux gestes : « Prendre RDV » et le lien « Poursuivre la résiliation ».
 */
import React from "react"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { AlertCard } from "../../molecules/AlertCard"
import { CancelFeesCardSkeleton } from "../../molecules/CancelFeesCard/CancelFeesCardSkeleton"

export function CancelFeesSkeleton() {
    return (
        <Stack gap="4">
            <Stack gap="0">
                <Skeleton textSize="text-base" width="100%" />
                <Skeleton textSize="text-base" width={200} />
            </Stack>
            <CancelFeesCardSkeleton />
            <AlertCard
                severity="info"
                message={
                    <Stack gap="1">
                        <Skeleton textSize="text-md" width={170} />
                        <Skeleton textSize="text-sm" width={240} />
                        <Skeleton textSize="text-sm" width={160} />
                    </Stack>
                }
            />
            <Skeleton shape="block" height={pushButtonBoxHeight("md")} />
            <Stack align="center">
                <Skeleton textSize="text-md" width={180} />
            </Stack>
        </Stack>
    )
}
